import { F as e, R as t, at as n, h as r, i, rt as a, t as o, v as s, w as c, x as l } from "./_plugin-vue_export-helper-CTQVpqU-.js";
//#region src/webcomponents/mobile-shell/MobileShell.ce.vue?vue&type=script&setup=true&lang.ts
var u = {
	class: "content",
	part: "content"
}, d = i(/* @__PURE__ */ o(/* @__PURE__ */ c({
	__name: "MobileShell.ce",
	props: {
		aspectRatio: {
			default: "1/2",
			type: null
		},
		maxWidth: {
			default: 330,
			type: Number
		},
		persistMobileShell: {
			type: Boolean,
			default: !1
		},
		marginTop: {
			default: 25,
			type: Number
		}
	},
	setup(i) {
		return (o, c) => (e(), s("div", {
			class: a(["mobile", { "hide-mobile-shell": !i.persistMobileShell }]),
			part: "screen",
			style: n({
				"--aspect-ratio": i.aspectRatio,
				"--max-width": `${i.maxWidth}px`,
				"--margin-top": `${i.marginTop}px`
			})
		}, [c[0] ||= l("<div class=\"cache-top\"><div class=\"camera\"></div></div><div class=\"buttons\"><div class=\"button small\"></div><div class=\"button long\"></div><div class=\"button long\"></div></div>", 2), r("div", u, [t(o.$slots, "default")])], 6));
	}
}), [["styles", ["*{box-sizing:border-box;margin:0;padding:0}.mobile{z-index:3;box-sizing:content-box;width:100%;aspect-ratio:var(--aspect-ratio);max-width:var(--max-width);margin-top:var(--margin-top);border:10px solid #000;border-radius:30px;position:relative;left:50%;transform:translate(-50%);box-shadow:5px 5px 5px #0000004d}.mobile:before{content:\"\";z-index:1;border-radius:20px;width:100%;height:100%;position:absolute;top:-1px;left:-1px;box-shadow:inset 2px 2px 3px #0000004d}.mobile:after{content:\"\";filter:blur(1px);border-top:.1rem solid #fffc;border-right:2px solid #0000;border-top-left-radius:25px;width:85%;height:50%;position:absolute;top:-7px;left:-5px}.content{z-index:5;-ms-overflow-style:none;scrollbar-width:none;border-radius:20px;width:100%;height:100%;position:absolute}.content::-webkit-scrollbar{display:none}.mobile .cache-top{z-index:6;background:#000;border-bottom-right-radius:20px;border-bottom-left-radius:20px;width:35%;height:15px;position:absolute;top:0;left:32.5%}.mobile .cache-top .camera{aspect-ratio:1;background:#ffffff4d;border-radius:50%;width:9%;max-width:10px;position:absolute;top:40%;right:5%;transform:translate(-50%,-50%)}.cache-top .camera:after{content:\"\";filter:blur(1px);background:#fff;border-radius:50%;width:25%;height:25%;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)}.mobile .buttons{width:5px;height:20%;position:absolute;top:10%;left:-12.5px}.mobile .button{background:#000;border-radius:30%;width:5px;margin-bottom:10px}.mobile .button.small{height:15%;margin-bottom:10px}.mobile .button.long{height:30%}@media only screen and (width<=768px){.hide-mobile-shell:after,.hide-mobile-shell .cache-top,.hide-mobile-shell .buttons{display:none}.hide-mobile-shell{border-width:0}.hide-mobile-shell .content{border:2px solid #000}}"]]]));
window.customElements.define("mobile-shell", d);
//#endregion
